<template>
  <div class="mc-form-register">
    <div class="mc-form-register-input">
      <br />

      <ion-label style="text-align: start; margin-bottom: 5px"
        >{{ $t("HitchHiking.register.hikeTitle") }} *</ion-label
      >
      <ion-radio-group
        :value="hitchHikeMode"
        @ionChange="onHitchHikeModeChange"
      >
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            value="driver"
            color="success"
            slot="start"
            >{{ $t("HitchHiking.register.driver") }}</ion-radio
          >
        </ion-item>
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            value="passenger"
            color="success"
            slot="start"
            >{{ $t("HitchHiking.register.passenger") }}</ion-radio
          >
        </ion-item>
        <ion-item lines="none">
          <ion-radio
            label-placement="end"
            value="both"
            color="success"
            slot="start"
            >{{ $t("HitchHiking.register.driverorpassenger") }}</ion-radio
          >
        </ion-item>
      </ion-radio-group>

      <div
        v-if="
          v$.user.hitchHikeDriver.$error || v$.user.hitchHikePassenger.$error
        "
      >
        <div class="mc-error-label">{{ $t("Validation.required") }}</div>
      </div>
      <br />

      <div class="text-left">
        <ion-label class="text-left" style="margin-top: 0px; display: block"
          >{{ $t("HitchHiking.register.verif-id") }}
        </ion-label>

        <div class="text-left">
          <p
            style="font-size: 15px"
            v-html="$t('HitchHiking.register.verif-id-info')"
          ></p>
        </div>

        <div class="text-left">
          <p
            style="font-size: 15px"
            v-html="$t('HitchHiking.register.verif-file-info')"
          ></p>
        </div>
      </div>
      <br />

      <ion-button
        class="mc-small-button"
        color="primary"
        fill="outline"
        expand="block"
        @click="$refs.docInput.click()"
      >
        <ion-icon class="ion-margin-end" name="create"></ion-icon>
        {{ $t("HitchHiking.register.verif-id-upload") }}
      </ion-button>
      <div
        class="d-flex align-center justify-center color-success"
        v-if="identityFile"
      >
        <ion-icon name="checkmark-circle" class="mr-3"></ion-icon>
        {{ $t("HitchHiking.register.ready-to-be-send") }}
      </div>
      <input
        ref="docInput"
        style="display: none"
        type="file"
        @change="changeDoc($event)"
      />

      <br />
    </div>
  </div>
</template>

<style lang="scss">
.mc-form-register {
  display: block;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .mc-form-register-input {
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: center;
  }

  .label-visible-by-all {
    float: left;
    font-size: 11px;
    opacity: 0.6;
    text-align: start;
    margin-top: 3px;
  }
}

.text-asterisk {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}

.color-success {
  color: var(--ion-color-success);
}

.mr-3 {
  margin-right: 10px;
}
</style>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  helpers,
} from "@vuelidate/validators";
import Compressor from "compressorjs";
import { toast } from "../../Shared/Mixin/toast.mixin";
import { hitchHikingStore } from "../HitchHiking.store";
import useVuelidate from "@vuelidate/core";

const checked = (value) => value === true;

const checkedDriver = (value, vm) =>
  value === true || vm.hitchHikePassenger === true;
const checkedPassenger = (value, vm) =>
  value === true || vm.hitchHikeDriver === true;

export default {
  name: "hitchHiking.compoleteRegisterStep2",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      checkedEmail: null,
    };
  },
  mixins: [toast],
  validations() {
    return {
      user: {
        hitchHikeDriver: {
          checkedDriver,
        },
        hitchHikePassenger: {
          checkedPassenger,
        },
      },
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.userStore.user;
      },
      set() {
        this.$store.commit("user_request_success", this.user);
      },
    },
    identityFile: {
      get() {
        return this.$store.state.hitchHikingStore.identityFile;
      },
    },
    // Nouvelle computed property pour gérer l'état du radio group
    hitchHikeMode: {
      get() {
        if (
          !!this.user &&
          this.user.hitchHikeDriver &&
          this.user.hitchHikePassenger
        ) {
          return "both";
        } else if (this.user.hitchHikeDriver) {
          return "driver";
        } else if (this.user.hitchHikePassenger) {
          return "passenger";
        }
        return null;
      },
      set(value) {
        switch (value) {
          case "driver":
            this.user.hitchHikeDriver = true;
            this.user.hitchHikePassenger = false;
            break;
          case "passenger":
            this.user.hitchHikeDriver = false;
            this.user.hitchHikePassenger = true;
            break;
          case "both":
            this.user.hitchHikeDriver = true;
            this.user.hitchHikePassenger = true;
            break;
          default:
            this.user.hitchHikeDriver = false;
            this.user.hitchHikePassenger = false;
        }
      },
    },
  },
  created() {},
  methods: {
    changeDoc(e) {
      const file = e.target.files[0];
      if (file) {
        this.compressFile(file);
      }
    },
    compressFile: function (file) {
      const context = this;
      if (file.type.includes("image")) {
        new Compressor(file, {
          convertSize: 1000000,
          success(result) {
            if (result) {
              context.uploadVerifId(
                new File([result], file.name, { type: result.type })
              );
            }
          },
          error(err) {
            context.presentToast(context.$t("Commons.error"), "danger");
          },
        });
      } else {
        context.uploadVerifId(new File([file], file.name, { type: file.type }));
      }
    },
    uploadVerifId(file) {
      this.$store.commit("hitch_hicking_update", file);
    },
    validate() {
      this.v$.$reset();
      this.v$.$touch();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    // Nouvelle méthode pour gérer le changement de mode
    onHitchHikeModeChange(event) {
      this.hitchHikeMode = event.detail.value;
    },

    // Anciennes méthodes conservées pour compatibilité si nécessaire
    changeHitchHikeDriver(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = false;
      }
    },
    changeHitchHikePassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = false;
        this.user.hitchHikePassenger = true;
      }
    },
    changeHitchHikeDriverOrPassenger(event) {
      if (event.detail.checked) {
        this.user.hitchHikeDriver = true;
        this.user.hitchHikePassenger = true;
      }
    },
  },
};
</script>
